var Environment;
(function (Environment) {
    Environment["PRODUCTION"] = "production";
    Environment["STAGING"] = "staging";
    Environment["DEVELOPMENT"] = "development";
})(Environment || (Environment = {}));

export { Environment };
